import { withInstall } from '@ideaz/utils'
import Select from './src/index'

export default withInstall(Select)
export * from './src/props'
